<template>
  <div style="width: 100%">
    <div v-if="generalPurposeCard" class="rcs-message-container">
      <div v-bind:style="messageStyle" :class="layoutClass">
          <img 
            v-if="RegExp(/image\/*/).test(mediaContentType)" 
            :src="mediaUrl || thumbnailUrl"
            :class="title || description || (links && links.length > 0) ? 'rcs-image' : 'rcs-radius-image'" 
          ></img>
          <video 
            v-if="RegExp(/video\/*/).test(mediaContentType)" controls :poster="thumbnailUrl"
            :style="{height: mediaHeight, objectFit: 'contain'}"
            :class="title || description || (links && links.length > 0) ? 'rcs-image' : 'rcs-radius-image'" 
          >
            <source :src="mediaUrl" :type="mediaContentType" />{{formatMessage({id:'5g.message.h5.tipmsg.msg1',defaultMessage:'您的浏览器不支持 HTML5 video 标签'})}}
          </video>
          <video 
            v-if="RegExp(/audio\/*/).test(mediaContentType)" controls :poster="thumbnailUrl"
            :style="{height: mediaHeight, objectFit: 'contain'}"
            :class="title || description || (links && links.length > 0) ? 'rcs-image' : 'rcs-radius-image'" 
          >
            <source :src="mediaUrl" :type="mediaContentType" />{{formatMessage({id:'5g.message.h5.tipmsg.msg1',defaultMessage:'您的浏览器不支持 HTML5 video 标签'})}}
          </video>
        <div class="rcs-content-con">
          <div v-if="title" class="rcs-title" v-bind:style="titleStyle">{{title}}</div>
          <div v-if="description" class="rcs-description" v-bind:style="descriptionStyle">{{description}}</div>
          <div v-for="link in links">
            <a v-if="link.reply" class="rcs-link" v-bind:style="linksStyle" v-on:click="handleLinkClick(link)">{{link.reply.displayText}}</a>
            <a v-if="link.action" class="rcs-link" v-bind:style="linksStyle" v-on:click="handleLinkClick(link)">{{link.action.displayText}}</a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="generalPurposeCardCarousel" class="con" >
      <div v-for="(content, index) in contentList" :key="index" class="generalPurposeCardCarousel" v-bind:style="messageStyle">
        <img 
          v-if="RegExp(/image\/*/).test(content.mediaContentType)" 
          :src="content.mediaUrl || content.thumbnailUrl" 
          :class="getImageClass(content)"
          :style="{height: content.mediaHeight}"
        ></img>
        <video 
          v-if="RegExp(/video\/*/).test(content.mediaContentType)" controls
          :class="getImageClass(content)" 
          :style="{height: content.mediaHeight, objectFit: 'contain'}"
          :poster="content.thumbnailUrl">
          <source :src="content.mediaUrl" :type="content.mediaContentType" />{{formatMessage({id:'5g.message.h5.tipmsg.msg1',defaultMessage:'您的浏览器不支持 HTML5 video 标签'})}}
        </video>
        <video 
          v-if="RegExp(/audio\/*/).test(content.mediaContentType)" controls 
          :class="getImageClass(content)" 
          :style="{height: content.mediaHeight, objectFit: 'contain'}"
          :poster="content.thumbnailUrl">
          <source :src="content.mediaUrl" :type="content.mediaContentType" />{{formatMessage({id:'5g.message.h5.tipmsg.msg1',defaultMessage:'您的浏览器不支持 HTML5 video 标签'})}}
        </video>
  
        <div class="rcs-content-con">
          <div v-if="content.title" class="rcs-title" v-bind:style="titleStyle">{{content.title}}</div>
          <div v-if="content.description" class="rcs-description" v-bind:style="descriptionStyle">{{content.description}}</div>
          <template v-for="link in content.links">
            <a v-if="link.reply" class="rcs-link" v-bind:style="linksStyle" v-on:click="handleLinkClick(link)">{{link.reply.displayText}}</a>
            <a v-if="link.action" class="rcs-link" v-bind:style="linksStyle" v-on:click="handleLinkClick(link)">{{link.action.displayText}}</a>
          </template>
        </div>
      </div>
    </div>

    <!-- <div v-if="text" class="text-tpl">{{text}}</div> -->
    <template v-if="text && location">
      <div v-if="location.longitude" class="mapCon">
        <MapItem :uniqueKey="createTime + 'map'"
          :latitude="location.latitude"
          :longitude="location.longitude"
          :address="location.address"
        >
        </MapItem>
      </div>
      <div v-else class="text-tpl">{{text}}</div>
    </template>

    <template v-if="file">
      <img v-if="RegExp(/image\/*/).test(file.fileType)" :src="file.fileUrl" class="rcs-radius-image" ></img>
      <video v-if="RegExp(/video\/*/).test(file.fileType)" controls class="rcs-radius-image" :poster="file.thumbnailUrl"><source :src="file.fileUrl" :type="file.fileType" />{{formatMessage({id:'5g.message.h5.tipmsg.msg1',defaultMessage:'您的浏览器不支持 HTML5 video 标签'})}}</video>
      <video v-if="RegExp(/audio\/*/).test(file.fileType)" controls class="rcs-radius-image" :poster="file.thumbnailUrl"><source :src="file.fileUrl" :type="file.fileType" />{{formatMessage({id:'5g.message.h5.tipmsg.msg1',defaultMessage:'您的浏览器不支持 HTML5 video 标签'})}}</video>
      
      <div v-if="RegExp(/application\/*/).test(file.fileType)" class="rcs-file">
        <img v-if="file.thumbnailUrl" :src="file.thumbnailUrl" class="thumbnailImage"></img>
        <a :href="file.fileUrl" class="fileLink" :download="file.fileName">{{file.fileName}}</a>
      </div>
    </template>

    <div class="rcs-button" v-if="showBtn">
      <div v-for="btn in buttons">
        <el-button v-if="btn.reply" class="button-suggestion" v-on:click="handleLinkClick(btn)" type="primary">{{btn.reply.displayText}}</el-button>
        <el-button v-if="btn.action" class="button-suggestion" v-on:click="handleLinkClick(btn)" type="primary">{{btn.action.displayText}}</el-button>
      </div>
    </div>

    <!-- <div>messageStyle: {{this.messageStyle}}</div>
    <div>titleStyle: {{this.titleStyle}}</div>
    <div>descriptionStyle: {{this.descriptionStyle}}</div>
    <div>linksStyle : {{this.linksStyle}}</div> -->
  </div>
</template>

<script>
import { queryChatbotList } from '../services'
import moment from 'moment'
import qs from 'qs'
import { lists, menuList } from './data.js'
import axios from 'axios'
import MapItem from '../components/MapItem'

const TALL_HEIGHT = '264px';  // 宽为220px
const SHORT_HEIGHT = '105px';
const MEDIUM_HEIGHT = '176px';

export default {
  name: 'TemplateCard',
  // 页面级组件的数据模型，影响传入数据的覆盖机制：private内定义的属性不允许被覆盖
  components: {
    MapItem
  },
  data () {
    const { rcsMessageInstanceDTO, createTime } = this.dataSource || {};
    const { contentType, text, message, file, suggestions } = rcsMessageInstanceDTO || {};
    // console.log('rcsMessageInstanceDTO', rcsMessageInstanceDTO)

    let location = {};
    if(text && text.indexOf('geo:') == 0){ // 地图
      const arr = text.split(';');
      const geoItem = arr.find(item => /geo:/.test(item));
      const rcsItem = arr.find(item => /rcs-l=/.test(item));
      if (geoItem) {
        const geoArr = geoItem.replace('geo:','').split(',');
        const [lat, lng] = geoArr || []; // 纬度在前
        let address;
        if(rcsItem){
          const rcsArr = rcsItem.split('=');
          address = rcsArr[1];
        }
        location = {
          longitude: lng, latitude: lat, address: decodeURI(address)
        }
      }
    }
   
    const { suggestions: buttons } = suggestions || {};

    const getMediaHeight = (mediaHeight) =>{
      switch(mediaHeight){
        case 'TALL_HEIGHT':
          return '264px';
        case 'MEDIUM_HEIGHT':
          return '196px';
        case 'SHORT_HEIGHT':
          return '105px';
        default:
          return '196px';
      }
    };

    const getLayoutClass = (cardOrientation, imageAlignment) => {
      // console.log('cardOrientation, imageAlignment',cardOrientation, imageAlignment);
      if(cardOrientation == 'VERTICAL'){
        return 'generalPurposeCard';
      } else if(cardOrientation == 'HORIZONTAL'){
        if(imageAlignment && imageAlignment == 'LEFT'){
          return 'generalPurposeCardHORIZONTAL_LEFT'
        } else if(imageAlignment == 'RIGHT'){
          return 'generalPurposeCardHORIZONTAL_RIGHT'
        }
      }
      return 'generalPurposeCard';
    };

    if(contentType == 'application/vnd.gsma.botmessage.v1.0+json' || contentType == 'multipart/mixed; boundary="next"'){
      const { generalPurposeCard, generalPurposeCardCarousel } = message && message.message || {}
      if(generalPurposeCard){
        const { content, layout: { cardOrientation, imageAlignment, style: cssUrl } } = generalPurposeCard || {};
        const { media: { mediaContentType, height: mediaHigh, mediaUrl, thumbnailUrl }, title, description, suggestions: links } = content || {};
        return {
          generalPurposeCard: true, generalPurposeCardCarousel: false, text: '', file: null,
          cssUrl, messageStyle: '', titleStyle: '', descriptionStyle: '', linksStyle: '',
          cardOrientation, imageAlignment, layoutClass: getLayoutClass(cardOrientation, imageAlignment),
          mediaContentType, mediaHeight: getMediaHeight(mediaHigh), mediaUrl, thumbnailUrl, 
          title, description, links, 
          buttons
        }
      } else if(generalPurposeCardCarousel){ // 多卡片，垂直布局，"cardWidth":"MEDIUM_WIDTH",
        const { content, layout: { style: cssUrl } } = generalPurposeCardCarousel || {};
        const contentList = content && content.map(item => {
          const { media: { mediaContentType, height: mediaHigh, mediaUrl, thumbnailUrl }, title, description, suggestions: links } = item || {};
          return { 
            mediaContentType, mediaHeight: getMediaHeight(mediaHigh), mediaUrl, thumbnailUrl,
            title, description, links
          }
        });
        return {
          generalPurposeCardCarousel: true, generalPurposeCard: false, text: '', file: null,
          cssUrl, messageStyle: '', titleStyle: '', descriptionStyle: '', linksStyle: '',
          contentList, buttons
        }
      } else {
        return {
          generalPurposeCardCarousel: false, generalPurposeCard: false, text, location, createTime, file: null,
          cssUrl: null, messageStyle: '', titleStyle: '', descriptionStyle: '', linksStyle: '',
          buttons
        }
      }
    }

    if(contentType == 'text/plain'){
      return {
        generalPurposeCardCarousel: false, generalPurposeCard: false, text, location, createTime, file: null,
        cssUrl: null, buttons
      }
    }

    if(contentType && contentType.indexOf('application/vnd.gsma.rcs-ft-http') > -1){
      let fileObject;
      const { list } = file || {};
      if(list && list.length > 0){
        fileObject = {};
        const thumbnail = list.find(item => item.type == 'thumbnail');
        if(thumbnail){
          fileObject.thumbnailUrl = thumbnail.data && thumbnail.data.url || null;
          fileObject.thumbnailType = thumbnail.contentType;
        }
        const fileContent = list.find(item => item.type == 'file');
        if(fileContent){
          fileObject.fileUrl = fileContent.data && fileContent.data.url || null;
          fileObject.fileType = fileContent.contentType;
          fileObject.fileName = fileContent.fileName;
        }
      }
      return {
        generalPurposeCardCarousel: false, generalPurposeCard: false, text: '', file: fileObject,
        cssUrl: null, buttons
      }
    }
  },

  props: {
    dataSource: Object,
    clickAction: Function,
    showBtn: Boolean,
  },

  methods: {
    getImageClass(content){
      const { title, description, links } = content || {};
      return title || description || (links && links.length > 0) ? 'rcs-image' : 'rcs-radius-image'
    },

    async fetchCss(url){
      try {
        const response = await axios.get(url);
        if(response && response.data){
          // console.log('response.data', response.data);
          const { data, status } = response;
          if(data && status == 200) {
            this.getStyleString(data);
          }
        }
      } catch(error) {
        console.log(error);
      }
    },

    // 解析css
    getCss(str){
      if(str && str.indexOf('{') > 0 && str.indexOf('}') > 0){
        const startIndex = str.lastIndexOf('{');
        const endIndex = str.lastIndexOf('}');
        const styleStr = str.substring(startIndex+1, endIndex);
        // console.log('styleStr',styleStr);
        return styleStr
      }
      return ''
    },

    getStyleString(cssText){
      if(cssText && typeof(cssText) === 'string'){
        const responseString = cssText.replace(/\n|\r|\s/g,"");
        const styleArray = responseString.split('message.content.');
        if(styleArray && styleArray.length == 4){
          this.messageStyle = this.getCss(styleArray[0]) + 'font-size: 14px';
          this.titleStyle = this.getCss(styleArray[1]) + 'font-size: 14px';
          this.descriptionStyle = this.getCss(styleArray[2]) + 'font-size: 14px';
          this.linksStyle = this.getCss(styleArray[3]) + 'font-size: 13px';
        }
      }
    },

    handleLinkClick(link){
      this.$emit('clickLink', link)
    },
  },

  created(){
    // console.log('cssUrl', this.cssUrl);
    this.cssUrl && this.fetchCss(this.cssUrl);
  },

  mounted(){
    // const cards = document.getElementsByClassName('generalPurposeCardCarousel')
    // console.log('generalPurposeCardCarousel', cards)
  }
}
</script>

<style lang="less" scoped>
  @import './styles.less';
  .text-tpl{
    float: left;
    background-color: #fff;
    padding: 10px;
    border-radius: 12px;
    font-size: 12px;
    color: #000000;
    display: inline-block;
  }
  .thumbnailImage{
    width: 40px;
    height: 40px;
    object-fit: cover;
  }
  .fileLink{
    cursor: pointer;
    text-align: left;
    font-size: 13px;
  }
  .con{
    display: flex;
    opacity: 1;
    flex-direction: row;
    overflow: auto;
    /* width: 100%; */
  }
  .mapCon{
    height: 250px;
    width: 250px;
    padding: 10px;
    background-color: #fff;
    border-radius: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/chatRoom/templateCard.vue